var _mask, _mask2, _mask3, _mask4, _mask5, _mask6, _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g4, _g5, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _g6, _g7, _path75, _path76, _path77, _path78;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComingSoonIlustradedEstudologia1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 672,
    viewBox: "0 0 464 672",
    width: 464,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 18,
    maskUnits: "userSpaceOnUse",
    width: 16,
    x: 411,
    y: 80
  }, /*#__PURE__*/React.createElement("path", {
    d: "m422.595 80.823c1.332.433 2.58 1.0908 3.69 1.945v14.842c-2.794 1.241-7.336-1.281-9.626-2.463-1.933-.998-3.866-2.626-5.457-4.176v-9.335c.501-.3268 1.035-.5993 1.594-.813z",
    fill: "#fff"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 18,
    maskUnits: "userSpaceOnUse",
    width: 16,
    x: 412,
    y: 80
  }, /*#__PURE__*/React.createElement("path", {
    d: "m415.9 80.176c-.404.039-.818.09-1.241.156-.9.1353-1.775.4085-2.593.81v10.646c1.403 1.284 2.998 2.536 4.593 3.359 2.416 1.247 7.341 3.987 10.073 2.222.434-.28.831-.599 1.187-.958v-12.077c-1.551-1.851-4.29-3.728-8.379-4.158z",
    fill: "#fff"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "c",
    height: 18,
    maskUnits: "userSpaceOnUse",
    width: 16,
    x: 170,
    y: 272
  }, /*#__PURE__*/React.createElement("path", {
    d: "m181.734 272.442c1.332.433 2.58 1.09 3.69 1.944v14.842c-2.794 1.24-7.337-1.281-9.626-2.462-1.933-.998-3.866-2.626-5.457-4.176v-9.336c.501-.326 1.035-.599 1.593-.812z",
    fill: "#fff"
  }))), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "d",
    height: 19,
    maskUnits: "userSpaceOnUse",
    width: 17,
    x: 171,
    y: 271
  }, /*#__PURE__*/React.createElement("path", {
    d: "m175.037 271.795c-.403.039-.817.09-1.24.156-.9.135-1.774.409-2.591.81v10.645c1.402 1.283 2.997 2.536 4.592 3.359 2.416 1.246 7.341 3.986 10.074 2.221.429-.275.826-.595 1.186-.956v-12.079c-1.55-1.849-4.29-3.725-8.378-4.155h-3.643z",
    fill: "#fff"
  }))), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    height: 11,
    maskUnits: "userSpaceOnUse",
    width: 23,
    x: 324,
    y: 523
  }, /*#__PURE__*/React.createElement("path", {
    d: "m341.928 523.138c.735.561 1.431 1.172 2.084 1.827 1.338 1.336 2.034 2.806 2.353 4.187v4.117c-.01.043-.02.087-.03.13h-20.631c-.54-.384-.984-.833-1.284-1.361v-5.835c.46-1.003 1.169-2.027 2.157-3.065h15.35z",
    fill: "#fff"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "f",
    height: 12,
    maskUnits: "userSpaceOnUse",
    width: 24,
    x: 323,
    y: 521
  }, /*#__PURE__*/React.createElement("path", {
    d: "m339.987 521.857c1.32.745 2.674 1.759 4.025 3.108 1.064 1.062 1.721 2.209 2.107 3.328v3.868h-21.625c-.112-.179-.207-.369-.283-.567-1.141-2.978-.292-6.293 3.72-9.737z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m329.73 493.367-149.068 86.2c-2.658 1.538-5.675 2.346-8.746 2.341-3.07-.004-6.085-.82-8.739-2.365l-48.79-28.41c-3.296-1.92-3.287-6.687.016-8.595l148.003-84.835c3.457-1.978 7.372-3.014 11.354-3.005 3.982.01 7.892 1.065 11.339 3.059l44.642 25.827c3.762 2.178 3.757 7.614-.01 9.783zm60.264-12.212-104.98-61.245c-3.192-1.862-6.818-2.852-10.514-2.869-3.696-.018-7.331.937-10.541 2.769l-209.9088 120.392c-5.037 2.91-5.037 10.184 0 13.093l105.9518 61.186c3.422 1.976 7.305 3.012 11.256 3.003s7.83-1.063 11.242-3.055l207.472-119.225c5.393-3.123 5.405-10.909.023-14.049",
    fill: "#442b8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.4345 642.514c1.028 2.917 2.953 8.392 3.812 10.833l-16.909 11.058c-.51-1.424-2.799-7.8-3.874-10.794zm83.4195-41.231-3.95-10.732 15.473-10.118c1.015 2.824 2.96 8.247 3.87 10.783zm-19.377 12.672-3.804-10.83 16.898-11.05 3.933 10.744zm-19.228 12.575-3.937-10.745 17.02-11.128c1.024 2.926 2.937 8.407 3.787 10.84zm-19.3555 12.66-3.826-10.822 16.9105-11.057c1.058 2.898 3.031 8.315 3.921 10.757zm-19.29 12.615c-.505-1.424-2.769-7.824-3.828-10.821l16.952-11.085c1.027 2.92 2.951 8.393 3.81 10.832l-16.935 11.074zm115.3195-72.465c-.359-.549-.922-.933-1.564-1.067s-1.311-.008-1.861.351l-16.9 11.053c-.6-1.665-2.85-7.907-3.884-10.771l18.132-11.856c.55-.359.934-.922 1.068-1.564.134-.643.008-1.312-.352-1.861-.359-.549-.921-.933-1.564-1.067-.642-.135-1.311-.008-1.861.351l-146.3585 95.7c-.5293.368-.8943.928-1.0172 1.56-.123.633.0057 1.289.3587 1.828s.9025.919 1.5315 1.06c.6291.14 1.2881.03 1.837-.308l11.637-7.61c1.04 2.906 2.986 8.36 3.86 10.806l-4.466 1.207c-.549.359-.9329.922-1.0672 1.564-.1342.642-.0079 1.311.3512 1.86s.9216.933 1.5637 1.067 1.3113.008 1.8603-.351l137.9795-88.527c.272-.178.507-.408.69-.676s.311-.57.378-.888c.066-.318.07-.646.009-.966-.06-.319-.183-.623-.361-.895z",
    fill: "#5a508c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m129.175 119.512c.008-.981-.245-1.947-.736-2.797-.49-.851-1.199-1.554-2.052-2.038l-21.275-12.056c-3.65-2.068-8.1784.553-8.2074 4.75l-1.395 209.535c-.0182 2.741-.7509 5.429-2.1258 7.8s-3.3445 4.343-5.7142 5.72l-79.06304 45.93c-3.634 2.11-3.65401 7.355-.03501 9.493l20.69705 12.229c.8365.494 1.7891.758 2.7607.764.9717.006 1.9276-.245 2.7703-.729l57.908-33.251c1.7-.976 36.4324-14.832 36.4704-19.044l-.002-226.307z",
    fill: "#442b8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.198 102.461-21.604-12.48c-3.045-1.7594-6.499-2.686-10.016-2.6865-3.516-.0006-6.971.925-10.016 2.6835l-102.58398 59.22c-2.43085 1.404-4.45028 3.422-5.85619 5.852-1.40591 2.429-2.148967 5.186-2.154811 7.993l-.55 241.943c-.003887 1.593.412486 3.159 1.207121 4.541.79463 1.381 1.93942 2.528 3.31888 3.325l25.16998 14.541 1.91 1.103 2.829 1.652c-.987-.683-3.011-2.668-2.815-7.437l.55-239.374c-.0005-3.419.899-6.779 2.6079-9.741 1.709-2.961 4.1674-5.421 7.1281-7.132l.026-.016 107.248-61.908s3.733-1.898 7.526.262l-3.925-2.34z",
    fill: "#442b8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.8574 369.053.745-169.702c.0121-2.748.7426-5.445 2.1192-7.823 1.3765-2.378 3.3511-4.355 5.7278-5.734l48.4246-28.086c3.537-2.051 7.962.526 7.925 4.616l-1.522 173.76c-.023 2.631-.732 5.21-2.057 7.483s-3.22 4.161-5.498 5.477l-45.2766 26.157c-4.718 2.725-10.612-.697-10.588-6.148zm97.0636-259.245c-1.254-4.994-7.079-7.77-11.87-5l-95.8766 55.387-11.923 6.888c-2.6304 1.52-4.8155 3.704-6.3367 6.334s-2.3251 5.613-2.3313 8.651l-.479 217.593-.08.046v24.948c0 5.148 5.57 8.366 10.026 5.792l11.811-6.824 9.781-5.65 63.2356-36.531 21.24-12.27c3.163-1.828 5.795-4.448 7.638-7.602s2.833-6.733 2.872-10.386l2.617-239.003c.007-.802-.102-1.602-.324-2.373z",
    fill: "#7763ae"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.9099 461.521-79.06298 45.93c-3.634 2.11-3.654 7.355-.036 9.493l20.69798 12.228c.8363.494 1.7887.758 2.7602.764.9714.007 1.9271-.245 2.7698-.728l57.909-33.251c1.699-.976 36.4321-14.832 36.4691-19.045 0 0-36.6861-18.191-41.5071-15.391",
    fill: "#442b8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m458.415 330.004-202.01-116.683c-1.996-1.153-3.648-2.818-4.786-4.823-1.137-2.005-1.719-4.278-1.684-6.583l1.547-102.677c0-.0333-.008-.0661-.025-.0951-.016-.029-.04-.0531-.068-.07-.029-.0168-.062-.0258-.095-.026-.033-.0001-.066.0085-.095.0251l-31.912 18.436-1.162 73.733-.581 36.861v.006l.006-.002 209.508 120.986 31.357-18.114c.085-.049.156-.121.205-.206.05-.085.075-.182.075-.281s-.025-.196-.075-.281c-.049-.085-.12-.157-.205-.206",
    fill: "#32c9d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m395.834 320.742c-.035 4.542-4.957 7.356-8.886 5.081l-159.728-92.427c-2.744-1.589-5.018-3.879-6.588-6.635-1.571-2.755-2.381-5.878-2.35-9.05l.559-55.669c.034-3.379 3.693-5.469 6.618-3.78l164.159 94.754c2.04 1.178 3.731 2.877 4.9 4.922 1.17 2.045 1.776 4.363 1.756 6.719l-.44 56.086zm23.135-88.097-220.18-126.983c-4.987-2.88-11.231.663-11.322 6.425l-.938 124.365c0 3.19.838 6.324 2.431 9.088s3.884 5.061 6.644 6.66l219.7 127.241c5.018 2.91 11.312-.655 11.404-6.458l1.939-123.067c.056-3.477-.811-6.906-2.511-9.94-1.7-3.033-4.172-5.562-7.167-7.33z",
    fill: "#74dbe1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m191.464 105.537c-.08.044-.13.074-.13.074z",
    fill: "#3dafa7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451.601 214.459-216.311-125.04c-2.41-1.3916-5.144-2.1241-7.926-2.1239-2.783.0002-5.517.733-7.926 2.1249l-24.394 14.08-3.579 2.037c.655-.358 3.817-1.877 7.295.111l219.143 126.546c3.304 1.91 6.037 4.668 7.916 7.989s2.836 7.084 2.772 10.899l-2.047 122.361c-.42 2.363-1.439 4.926-3.813 6.114l29.662-17.05c1.917-1.108 3.514-2.693 4.636-4.602 1.123-1.908 1.732-4.074 1.769-6.288v-120.87c.112-6.7-1.394-12.937-7.196-16.289",
    fill: "#32c9d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m463.675 449.573-202.009-116.683c-4.065-2.347-38.862 14.781-38.862 14.781v.007l.006-.003 209.508 120.986 31.357-18.114c.085-.049.156-.12.206-.206.049-.085.075-.182.075-.281s-.026-.196-.075-.281c-.05-.086-.121-.157-.206-.206",
    fill: "#442b8c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.749 372.566c-3.343-1.945-7.139-2.977-11.006-2.991-3.868-.015-7.671.989-11.029 2.909l-155.6 89.265v40.171l159.739-91.149c5.056-2.902 12.415-4.197 17.46-1.276l83.858 48.526c.12.07.257.106.395.106.139.001.275-.036.395-.105.121-.069.221-.169.29-.289.07-.12.106-.256.106-.395v-35.538l-84.608-49.233z",
    fill: "#c6c6c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.73 408.367-149.068 86.2c-2.658 1.538-5.675 2.346-8.746 2.341-3.07-.004-6.085-.82-8.739-2.365l-48.79-28.41c-3.296-1.92-3.287-6.687.016-8.595l148.003-84.835c3.457-1.978 7.372-3.014 11.354-3.005 3.982.01 7.892 1.065 11.339 3.059l44.642 25.827c3.762 2.178 3.757 7.614-.01 9.783zm60.264-12.212-104.98-61.245c-3.192-1.862-6.818-2.852-10.514-2.869-3.696-.018-7.331.937-10.541 2.769l-209.9088 120.392c-5.037 2.91-5.037 10.184 0 13.093l105.9518 61.186c3.422 1.976 7.305 3.012 11.256 3.003s7.83-1.063 11.242-3.055l207.472-119.225c5.393-3.123 5.405-10.909.023-14.049",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m389.37 410.482-207.42 119.156c-3.249 1.879-6.935 2.87-10.688 2.874s-7.441-.98-10.694-2.852l-105.41-60.7c-.703-.42-4.62-2.943-4.867-7.21v33.903c0 4.896 2.62 9.418 6.869 11.85l102.582 58.71c3.505 2.006 7.475 3.055 11.513 3.044 4.038-.012 8.002-1.085 11.495-3.112l204.612-117.862c3.745-2.144 6.66-5.228 6.66-10.421v-34.663c0 3.205-1.287 5.437-4.651 7.283",
    fill: "#c6c6c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.9707 533.72c.104-.566.792-1.384 1.284-1.17.27.118.581.319.843.467l11.677 6.569.03 3.159c-.978-.552-10.948-6.187-12.597-7.113-.34-.192-.813-.361-1.043-.691-.24-.345-.268-.821-.194-1.221",
    fill: "#dc7b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.9707 533.72c.104-.566.792-1.384 1.284-1.17.27.118.581.319.843.467l11.677 6.569.008.844c-.977-.552-10.94-6.2-12.597-7.113-.638-.352-1.215.403-1.215.403z",
    fill: "#f29793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.5297 555.733c.113-.566.812-1.373 1.302-1.15.267.122.576.328.836.479l11.577 6.743-.017 3.159c-.97-.567-10.855-6.35-12.49-7.302-.337-.197-.807-.373-1.032-.706-.236-.348-.256-.824-.176-1.223",
    fill: "#dc7b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.5303 555.733c.113-.566.812-1.373 1.302-1.15.267.122.576.328.836.479l11.577 6.743-.005.843c-.97-.566-10.847-6.362-12.488-7.3-.633-.362-1.222.385-1.222.385",
    fill: "#f29793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.9706 577.956c.105-.566.794-1.382 1.286-1.167.27.118.581.32.842.468l11.668 6.586.025 3.16c-.976-.555-10.939-6.204-12.587-7.133-.34-.192-.812-.362-1.042-.692-.24-.345-.267-.82-.192-1.222",
    fill: "#dc7b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.9707 577.956c.105-.566.794-1.382 1.286-1.167.27.118.581.32.842.468l11.668 6.586.007.843c-.977-.553-10.933-6.215-12.587-7.13-.637-.353-1.216.4-1.216.4",
    fill: "#f29793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.516 599.993c.111-.564.81-1.373 1.3-1.15.267.12.576.325.836.475l11.592 6.72-.01 3.158c-.97-.565-10.869-6.327-12.505-7.275-.339-.196-.809-.37-1.034-.704-.237-.348-.258-.824-.179-1.224",
    fill: "#dc7b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.5156 599.993c.111-.564.81-1.373 1.3-1.15.267.12.576.325.836.475l11.592 6.72-.003.843c-.97-.565-10.86-6.34-12.504-7.275-.634-.36-1.22.387-1.22.387",
    fill: "#f29793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.015 622.109c.111-.563.81-1.373 1.3-1.152.267.123.576.327.836.478l11.593 6.716-.01 3.16c-.97-.564-10.869-6.326-12.506-7.274-.338-.196-.808-.37-1.034-.703-.237-.349-.258-.825-.179-1.225",
    fill: "#dc7b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.0146 622.109c.111-.563.81-1.373 1.3-1.152.267.123.5761.327.8361.478l11.5929 6.716-.0029.844c-.97-.564-10.8621-6.338-12.5051-7.272-.634-.36-1.22.386-1.22.386",
    fill: "#f29793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.4967 644.257c.109-.565.803-1.377 1.293-1.158.269.12.579.323.84.472l11.6229 6.665.005 3.158c-.973-.56-10.9-6.275-12.54-7.215-.338-.194-.81-.367-1.036-.699-.24-.347-.2619-.823-.1849-1.223z",
    fill: "#dc7b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.4971 644.257c.109-.565.803-1.377 1.293-1.158.269.12.579.323.84.472l11.623 6.665.002.843c-.974-.56-10.891-6.289-12.54-7.215-.634-.357-1.218.393-1.218.393",
    fill: "#f29793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.2639 498.05c.3117.091.6024.243.8554.447.2529.204.4633.456.6189.741.1557.285.2536.598.2878.921.035.323.006.649-.0861.961l-49.508 168.389c-.0889.315-.2394.609-.4426.865-.2033.256-.4554.47-.7417.628-.2862.158-.601.258-.9261.293-.3251.036-.6541.007-.9679-.085s-.6062-.246-.8603-.452c-.254-.206-.4648-.46-.62-.748-.1551-.288-.2517-.604-.284-.929-.0324-.326.0001-.654.0956-.967l49.51-168.388c.0912-.312.243-.603.4467-.856s.4554-.463.7406-.619.5983-.254.9213-.288c.3231-.035.6498-.005.9614.087",
    fill: "#f29793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.2643 498.05c.3117.091.6024.243.8553.447.253.204.4633.456.619.741.1556.285.2536.598.2884.921.034.323.005.649-.0867.961l-49.508 168.389c-.0915.312-.2435.602-.4473.855s-.4555.463-.7405.619c-.2851.156-.5981.254-.921.288-.323.035-.6496.006-.9612-.086 0 0 1.006.06 1.64-2.096l49.508-168.39c.561-1.908-.246-2.65-.246-2.65",
    fill: "#dc7b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.9924 489.565c.3116.091.6022.243.8551.447s.4632.456.6188.741.2536.598.2883.921c.0346.323.0054.649-.0862.961l-49.342 167.766c-.2.612-.6304 1.121-1.1998 1.421-.5694.299-1.2331.366-1.8504.184-.6173-.181-1.1397-.596-1.4565-1.156-.3167-.56-.4029-1.221-.2403-1.844l49.341-167.765c.0915-.312.2435-.602.4473-.855s.4555-.463.7405-.619c.2851-.156.5981-.253.921-.288.323-.035.6496-.006.9612.086",
    fill: "#f29793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.9919 489.565c.3116.091.6022.243.8551.447s.4632.456.6188.741.2536.598.2883.921c.0346.323.0053.649-.0862.961l-49.343 167.766c-.0915.312-.2435.602-.4473.855s-.4555.463-.7406.619c-.285.156-.598.253-.9209.288-.323.035-.6496.006-.9612-.086 0 0 1.006.06 1.64-2.096l49.342-167.765c.562-1.91-.245-2.65-.245-2.65",
    fill: "#dc7b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.1182 513.361c.108-.564.8-1.377 1.292-1.16.27.12.579.322.84.473.675.384 11.444 6.537 11.633 6.646l.009 3.159c-.973-.558-10.907-6.26-12.55-7.197-.34-.193-.81-.366-1.037-.697-.24-.347-.264-.823-.187-1.224",
    fill: "#dc7b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.1182 513.361c.108-.564.8-1.377 1.292-1.16.27.12.579.322.84.473.675.384 11.444 6.537 11.633 6.646l.003.843c-.974-.558-10.9-6.273-12.55-7.197-.635-.356-1.218.395-1.218.395",
    fill: "#f29793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.625 105.576c-.015-1.615-1.144-3.597-2.542-4.404-.865-.5-2.371-.843-3.267-.36-.985.532-.493 17.778-1.201 18.387-.772.665-21.917 5.754-21.917 5.754s-5.453-.33-6.831 1.065c-.862.874.139 1.581 1.112 1.317.972-.266 1.943-.443 2.562-.266 0 0-2.378 2.436-4.065 3.304-1.824.937 1.05 3.747 4.33 2.76 3.278-.988 2.828-5.003 4.507-5.446 0 0 23.129-2.862 24.19-3.843 1.06-.982 3.143-16.056 3.122-18.269",
    fill: "#c37a76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.273 19.38s6.75-3.786 10.072-3.251c0 0 .93-14.14403-5.643-12.85703-6.573 1.285-5.536 13.78603-4.429 16.10803",
    fill: "#e199b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m223.481 26.259c2.197 4.227 7.183 8.495 8.38 8.603 1.196.108 13.271 3.669 14.312 4.337 1.041.669.02 2.912 2.026 4.3 2.006 1.39 4.573.117 3.543-.92-.954-.96-1.805-3.677-1.805-3.677.458.015 1.08.349 1.68.743.6.392 1.434.134 1.042-.65-.627-1.25-4.398-2.222-4.398-2.222s-12.308-5.535-13.632-6.16c-.582-.273-3.969-6.462-5.252-9.001-1.145-2.266-3.917-5.236-7.019-3.9-2.782.975.746 7.822 1.123 8.547z",
    fill: "#f7e5e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.905 20.856c.694 2.204.814 4.907 2.285 6.763 0 0 .192 2.095-1.237 4.286-.798 1.222-1.4 5.32.182 10.11 1.11 3.356 1.386 4.562 1.386 4.562l-20.246 11.842c-.713-3.625.293-7.404 1.2-9.275 1.713-3.535 2.48-9.24-.355-14.608-2.835-5.37-2.66-9.553-1.481-10.463 2.782-2.147 8.338-5.295 8.338-5.295v-1.914l4.525-2.708v3.33l2.803.634c1.456.26 2.548 2.573 2.6 2.736",
    fill: "#f7e5e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.306 18.525s.464 1.247-.854 1.498c-1.5.286-4.53-.413-4.475-1.245.068-1.015 0-1.914 0-1.914s3.551-.07 5.33 1.66",
    fill: "#e5d7d6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.157 101.518s1.077 5.338 2.049 9.815c.795 3.668-2.5 5.694-4.585 2.025-2.086-3.67-1.487-9.088-.857-10.991l3.393-.85z",
    fill: "#f7e5e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.737 49.596c-4.018-.071-6.756 2.08-6.714 5.859.038 3.452 3.31 24.12 3.31 24.12l2.475 22.859s2.411.597 3.349-.916l2.081-22.705s3.5-29.073-4.501-29.217",
    fill: "#f7e5e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.81 45.31c-4.02-.031-7.405 2.12-7.43 5.572-.024 3.45 2.477 24.502 2.477 24.502l2.475 22.859s2.412.597 3.35-.915l2.627-23.801s5.501-28.145-3.5-28.217",
    fill: "#f7e5e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m227.681 97.327s6.27 3.218 7.407 4.607c1.14 1.39-1.85 3.792-5.967 1.105-4.115-2.687-4.75-3.539-4.884-5.26z",
    fill: "#f7e5e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.157 101.518s2.246 9.842-.024 10.449c-2.494.667-3.368-7.45-3.37-9.6 0 0-.526 1.094-.574 1.567-.047.472-.645 3.535-.12 6.086.527 2.55 2.143 5.795 4.599 5.559 2.456-.237 1.949-4.188 1.807-4.764-.26-1.064-1.83-8.862-2.272-9.61zm9.524-4.19s5.906 3.264 4.562 4.271c-1.343 1.008-6.825-1.616-8.005-4 0 0-.798 1.956.462 2.892 0 0 4.184 3.181 5.91 3.914 1.914.814 4.176-.008 4.652-.448s.772-1.757-1.429-3.334c-2.199-1.576-5.613-3.345-6.112-3.635zm-5.323-79.616s2.975 4.144 3.403 5.572c.406 1.352-5.105 4.745-8.968 5.394-.532.09-1.068-.113-1.446-.498-1.543-1.574-4.443-5.8-4.443-5.8l-.429.285s7.381 8.953 2.143 12.478c-1.524.761-2.048.523-2.048.523s1.763 6.953 1.096 9.763-.19 2.286-.19 2.286 6.142.571 9.285-.238c3.144-.81 6.62-3.619 7.334-5.81.095-.619-1.334-4.619-.38-7.857.952-3.239 1.904-3.239 1.952-5.43.047-2.19-5.572-7.953-6.954-10.905z",
    fill: "#005477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m225.153 17.639c.955-.955 1.705-3.444 1.705-5.877 0-1.31-.41-2.51302-.732-3.18302-.26-.538-.373-2.853-.511-3.331-.333-1.153-1.287-2.888-4.113-2.915-2.826-.025-4.51 2.445-5.128 3.776-1.468 3.157-.162 6.41302-.162 6.41302-.564-.63-1.469-1.07-2.166-1.022-.795.056-1.16.8-.638 1.573.26.385.955.764 1.228.884 3.233 6.25 9.826 4.373 10.517 3.682",
    fill: "#f7e5e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.456 11.523c-.136-.023-.273-.0304-.41-.022-.795.055-1.16.799-.638 1.572.06.09.147.18.245.268.138.12.3.236.459.334z",
    fill: "#f4dbd7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.343 83.059c.025.274.25.474.526.478.77.01 2.31-.171 3.655-.724 1.238-.51 2.33-1.306 2.951-1.812.362-.295.604-.697.69-1.156.506-2.717 2.07-12.405 2.573-15.748.572-3.785.072-11.93-.857-13.715-.929-1.786-3.929-9.215-3.929-9.215s-1.357 3.929-7.287 5.858c-1.633.53 1.31 32.124 1.678 36.034",
    fill: "#f29793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.666 47.025c-2.571.32-8.43-.143-9.357-.5 0 0-2.643 4.07-2.787 8.5-.127 3.977 2.853 25.283 3.774 30.115.107.562.619.949 1.189.902.868-.074 2.168-.235 3.252-.585 1.429-.462 2.529-1.222 3.074-1.701.228-.201.394-.443.506-.725.809-2.024 4.44-12.864.349-36.006",
    fill: "#f29793"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.963 2.52998s-3.44-2.294999-7.654.062c-4.214 2.358-5.5 9.50102-4.643 13.93002.857 4.43 6.57 3.5 6.57 3.5s-2.641-5.357-.855-8.143c1.785-2.78702-.123-7.98302 6.582-9.34902",
    fill: "#eda4c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.167 81.026s3.75.43 8.357-3.07c0 0 .036 2.215-.536 2.715-.328.287-1.428 1.428-3.464 2.142-2.036.715-3.272.768-3.654.724-.382-.045-.493-.16-.526-.478-.034-.317-.177-1.246-.177-2.032zm-10.157 2.573s4.488.476 9.097-3.024c0 0 .035 2.214-.536 2.714-.329.288-1.656 1.5-3.69 2.214-2.037.715-3.786.65-4.168.605-.38-.045-.492-.16-.526-.477-.033-.318-.177-1.247-.177-2.032zm9.442-4.644s1.57-5.5 1.429-20.787z",
    fill: "#dc7b6a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.667 8.23598-3.5 1.571-.93-.643-.142 1.07202-4.43 2-.284-1.57-.5 1.5s-1.286.213-1.358-.93c-.071-1.143-1.532-7.41102 3.929-8.57102 5.715-1.216 7.072 1.427 7.215 5.571",
    fill: "#eda4c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.094 19.856s-2.23-2.661-.687-6.783c0 0-1.17 2.926.687 6.783z",
    fill: "#e199b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.094 10.236s.43-1.47603-.095-2.76203c0 0 .333 1.763.095 2.76303",
    fill: "#bf94b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.987 12.754s.5-1.232 1.09-3.05402c0 0-.644 1.26802-1.09 3.05402z",
    fill: "#e199b4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.047 46.6076 20.273-11.705 170.422 98.3924-20.274 11.705z",
    fill: "#eddc13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.047 46.6076v3.766l170.422 98.3914-.001-3.765z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.742 133.294v3.766l-20.273 11.705-.001-3.766z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m268.404 62.8273 10.143-5.843.727.42-10.143 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.604 61.1886 5.117-2.962.728.419-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.172 62.6701 5.117-2.962.728.419-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m280.888 64.2013 5.117-2.963.728.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.116 67.257 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.684 68.7384 5.117-2.963.728.42-5.117 2.962z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m291.399 70.2687 5.117-2.963.728.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m296.116 73.0714 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.684 74.5529 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.399 76.0831 5.117-2.962.728.419-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m306.282 78.923 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m308.85 80.4044 5.117-2.963.728.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m311.565 81.9347 5.117-2.962.728.419-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m316.56 84.8488 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.127 86.3302 5.117-2.963.728.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m321.843 87.8605 5.117-2.962.728.419-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m326.837 90.8117 5.117-2.963.727.42-5.117 2.962z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m329.404 92.2931 5.117-2.963.728.42-5.117 2.962z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m332.12 93.8234 5.117-2.963.728.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m337.17 96.755 5.117-2.962.727.42-5.117 2.962z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m339.737 98.2365 5.117-2.962.728.42-5.117 2.962z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m342.453 99.7677 5.117-2.963.728.42-5.117 2.9633z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.41 102.681 5.117-2.9622.727.4192-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m349.978 104.162 5.117-2.962.728.419-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m352.693 105.693 5.117-2.963.728.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m357.891 108.755 5.117-2.963.728.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.459 110.236 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m363.175 111.768 5.117-2.963.727.42-5.117 2.962z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.021 114.588 5.117-2.963.727.42-5.118 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m370.588 116.069 5.117-2.963.728.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.304 117.601 5.117-2.963.728.42-5.117 2.962z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m378.131 120.384 5.117-2.962.728.419-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m380.699 121.865 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.415 123.397 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m388.594 126.44 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.161 127.921 5.117-2.963.728.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m393.877 129.451 5.117-2.962.728.419-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m278.676 68.7531 10.143-5.843.726.419-10.142 5.844z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m258.133 56.8517 10.144-5.843.726.42-10.142 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.333 55.214 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m267.9 56.6955 5.117-2.963.728.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m270.617 58.2257 5.117-2.962.727.42-5.117 2.962z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.861 50.8771 10.144-5.843.726.42-10.142 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.062 49.2384 5.117-2.962.728.42-5.117 2.962z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m257.63 50.7199 5.117-2.962.727.42-5.117 2.962z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m260.346 52.2511 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m237.591 44.9015 10.143-5.843.727.42-10.143 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m244.791 43.2638 5.117-2.963.727.42-5.117 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.358 44.7453 5.117-2.963.727.42-5.116 2.963z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.074 46.2765 5.117-2.963.728.42-5.117 2.962z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.946 74.6788 10.144-5.843.726.419-10.142 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m299.218 80.6046 10.143-5.844.727.42-10.143 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.489 86.5294 10.143-5.843.726.42-10.142 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m319.76 92.4552 10.144-5.843.726.42-10.142 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.031 98.381 10.143-5.843.727.42-10.143 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m340.303 104.307 10.143-5.8432.727.42-10.143 5.8432z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m350.573 110.233 10.144-5.843.726.42-10.142 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.845 116.158 10.144-5.843.726.42-10.142 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.116 122.084 10.143-5.843.727.42-10.143 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m381.388 128.01 10.143-5.843.726.42-10.142 5.843z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m391.658 133.936 10.144-5.843.726.419-10.142 5.844z",
    fill: "#d6c313"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m422.806 102.109-2.37 11.26s2.963 3.63 6.963 4.073c0 0 5.777-12.665-.149-16.37-2.074-1.037-3.888-.852-4.444 1.037",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.816 100.812c-1.577.53-3.628 1.835-3.628 1.835v-4.021l-6.349 3.8v2.686s-4.245 1.935-8.148 4.947c-1.655 1.277 2.325 5.499 2.89 14.985.505 8.503-1.112 9.668.222 25.173l22.966-12.504s.296-18.42-2.928-32.444c0 0-1.568-5.617-5.025-4.457z",
    fill: "#c37a76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.673 102.454c-2.15-1.468-4.103-7.378-2.135-14.148 1.966-6.77 9.339-6.667 9.339-6.667s6.752.188 7.988 5.385c1.108 4.663.526 7.622-1.533 9.74-2.216 2.28-11.51 7.16-13.66 5.69",
    fill: "#c37a76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.788 89.754c2.855 1.957 1.523 3.719 2.314 6.166.536 1.653.862 5.057 2.423 5.164 4.296.294 10.272-3.439 11.158-5.034 1.11-1.996 1.65-4.736 1.013-7.567-.935-4.151-4.672-7.817-11.831-6.772-5.286.772-7.895 6.112-5.077 8.043",
    fill: "#005477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.92 94.41s.023-1.258 1.2-1.258c.747 0 1.019.814 1.019 1.366 0 .641-.677 1.532-1.737 1.532zm-.92 21.048c0-.684-.18-1.422-.476-2.133l.002-.014h-.006c-.54-1.288-1.48-2.484-2.55-3.102-1.032-.596-1.948-.522-2.495.078-.338.37-3.263 20.003-3.83 20.504-1.068.95-9.485 9.267-10.25 9.832-1.591 1.176-2.952-.244-3.707-.217-.756.027-1.538.932-1.538.932-2.63.504-4.895 2.053-4.391 4.654.316 1.631 2.538 1.548 4.884 1 2.848-.668 4.593-1.782 4.593-1.782s14.018-9.273 14.735-10.757c2.553-5.279 5.029-18.2 5.029-18.995",
    fill: "#c37a76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.14 207.031s4.543 4.395 7.802 4.617c3.26.222 3.851-2.667 3.555-3.778-.296-1.11-1.06-3.283-5.802-5.506z",
    fill: "#003c57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.77 137.713-13.927 7.556c-.928 6.135 2.494 31.512 2.494 31.512l2.923 26.041c-1.578-.817-3.16-.824-3.886-.421-.889.495-1.679 1.482 1.383 4.543 1.112 1.113 5.235 4.162 7.901 3.556 1.87-.425.976-3.972.976-3.972l-1.174-30.594s5.187-15.194 5.531-24.568c.297-8.073-2.222-13.653-2.222-13.653",
    fill: "#c37a76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m419.622 206.513s.024-.47.246-.543c.223-.074 4.84 4.147 7.63 4.493 1.422.177 2.296-1.024 2.197-3.543l.223-.173s.963 2.84-.704 3.84c-1.537.922-4.037.716-9.592-4.074",
    fill: "#003c57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m423.261 202.822-.077-1.16c-1.2-.589-2.773-1.249-4.34-.779-2.222.667-3.11 2.222-1.852 3.925 1.26 1.704 2.15 2.223 2.15 2.223l4.12-4.209zm-14.157 9.431s4.543 4.396 7.802 4.617c3.26.223 3.852-2.666 3.555-3.777-.295-1.11-1.06-3.284-5.8-5.506z",
    fill: "#003c57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m431.62 136.182s3.927 5.11 2.89 18c-1.037 12.888-3.778 16.073-3.778 16.073s-10.82 6.523-11.555 4.593c-.913-2.395-1.728-22.05-1.876-24.493-.15-2.444-1.093-6.304-1.093-6.304l15.413-7.87z",
    fill: "#005477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m427.226 140.133-18.423 10.084 5.115 58.097c-.256-.159-.512-.319-.766-.481-1.876-1.184-3.929-1.224-5.467-.337-1.537.888.431 3.597 2.604 5.276 2.172 1.678 5.53 4.345 8 3.654 2.468-.691 1.728-4.345 1.728-4.345s0-31.885.32-35.3c.321-3.415 7.494-29.661 6.89-36.648",
    fill: "#c37a76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m404.548 111.48-2.334 11.222s2.964 3.63 6.964 4.074c0 0 5.776-12.666-.15-16.37-1.703-1.186-3.59-1.52-4.48 1.074",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.659 149.367s1.537 30.13 1.53 31.307c-.006 1.177 11.933-4.069 12.377-5.18.445-1.11 7.31-27.507 4.98-37.164z",
    fill: "#005477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.436 105.296s1.52 1.702 5.186-.26c3.666-1.964 1.703-2.63 1.703-2.63s2.444-1.37 3.037-1.592c.593-.223 2.221-1 3.963 1.037 1.74 2.036 3.135 8.006 3.493 10.354.358 2.35 1.502 24.391 1.642 24.973 0 0-5.427 7.087-24.32 14.041 0 0-.74-16.185-.444-19.962.296-3.778 5.518-17.222.888-20.74-1.11-.482-2.888-.742-2.888-.742s6.777-4.48 7.74-4.48",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m413.919 208.314-.078-1.16c-1.2-.59-3.467-1.52-5.033-1.048-2.223.666-3.112 2.222-1.853 3.926 1.26 1.703 2.149 2.22 2.149 2.22z",
    fill: "#003c57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.473 86.851s-2.205-3.052.84-2.617c1.037.148 1.975 1.185 1.975 1.185z",
    fill: "#d6a732"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m409.104 212.253s.024-.469.247-.543c.222-.074 4.84 4.147 7.63 4.493 1.421.177 3.233-.617 3.135-3.135l.222-.172s.321 2.715-1.334 3.407c-1.653.69-4.344.74-9.9-4.05z",
    fill: "#003c57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.659 95.146c2.416 1.248 7.34 3.988 10.073 2.224 2.733-1.765 4-5.037 2.667-10.37-.67-2.673-5.224-8.141-14.74-6.667-5.26.815-7.037 5.48-7.186 6.518 0 0 4.593 5.926 9.186 8.296",
    fill: "#f9c638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m416.659 95.146c2.416 1.248 7.34 3.988 10.073 2.224 2.733-1.765 4-5.037 2.667-10.37-.67-2.673-5.224-8.141-14.74-6.667-5.26.815-7.037 5.48-7.186 6.518 0 0 4.593 5.926 9.186 8.296",
    fill: "#eddc13"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m411.202 81.073s8.444-1.852 12.666 4.52c4.223 6.37 1.63 13.11 1.63 13.11",
    stroke: "#d6c313"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m412.066 80.308s9.334-1.407 13.555 4.963c4.222 6.37 1.334 12.963 1.334 12.963",
    stroke: "#d6c313"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m206.664 38.71c-.004-1.364 1.019-12.949 1.31-13.663.644-1.572 2.239-2.119 2.239-2.119.997.575 2.488 3.194 2.488 4.345 0 .406-.892 9.037-.892 9.037s6.935 5.833 12.059 9.064c0 0 3.162.895 3.672.686.509-.209.903.213.992.532.088.318-.091.604-.528.676-.437.071-.906.055-.906.055 1.579 1.074 2.596 2.948 1.53 4.508-.666.978-2.097.296-3.477-.726-1.675-1.242-2.503-2.464-2.503-2.464s-13.478-6.72-14.482-7.51c-.91-.716-1.498-1.005-1.502-2.42",
    fill: "#f7e5e3",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m227.58 6.953s.74 0 1.037.84c.296.84-3.407 2.863-6.567 3.16-1.673.156-3.457-.247-3.457-.247s2.716-3.358 8.987-3.753z",
    fill: "#d6a732",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m210.592 9.56999c-.144-.09784-.257-.23631-.323-.39792-.065-.16161-.082-.3391-.047-.51008.301-1.451 1.061-5.65999 4.024-7.33799 3.615-2.048004 8.296-1.483004 11.062 1.382 2.765 2.864 2.271 4.246 2.271 4.246s-5.259 1.078-8.987 3.754c0 0-4.628 1.1-8-1.13601",
    fill: "#f9c638",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m210.592 9.56999c-.144-.09784-.257-.23631-.323-.39792-.065-.16161-.082-.3391-.047-.51008.301-1.451 1.061-5.65999 4.024-7.33799 3.615-2.048004 8.296-1.483004 11.062 1.382 2.765 2.864 2.271 4.246 2.271 4.246s-5.259 1.078-8.987 3.754c0 0-4.628 1.1-8-1.13601",
    fill: "#eddc13",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m226.295 7.81499s-2.665-10.81-13.775-6.145m12.146 6.666s-5.48-11.48-13.851-3.705z",
    stroke: "#d6c313"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m318.397 622.343c-7.182-4.146-24.797 1.12-22.496 12.987s13.826 9.212 19.426 7.999c12.497-2.707 17.432-12.694 10.251-16.84l-7.18-4.146zm86.507-59.34.033-.035-.9-.399v-1.77l-.122.07c.314-.265.301-.768-.073-.985l-22.023-12.71.004-.002c-.537-.31-1.146-.474-1.767-.474-.62 0-1.229.164-1.766.474l-29.553 17.062c-1.969-1.87-5.059-2.48-7.736-.934l-22.9 13.221.002.003c-.241.088-.397.34-.397.726 0 .686.481 1.52 1.075 1.862.356.206.67.185.866-.01l22.371-13.974c1.582-.988 3.452-.753 4.737.251l-1.884 1.088-1.864 1.076v12.874c0 .43.114.842.321 1.2l-7.967 4.601c-.113.022-.216.081-.291.168l-.003.001.001.002c-.114.131-.182.33-.182.585 0 .685.482 1.52 1.076 1.862.241.14.462.171.64.12l.008.013.065-.04c.038-.018.074-.04.107-.067l8.862-5.536 19.702 11.375c.718.415 1.532.633 2.36.633.829 0 1.643-.218 2.361-.633l13.161-7.61c.613 2.04 1.765 3.501 3.309 4.266l2.111 1.03.01-.025c2.137 1.148 5.038.944 8.242-.906 6.561-3.788 11.88-13 11.88-20.576 0-4.01-1.5-6.74-3.876-7.877",
    fill: "#5a508c",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m149.567 287.6s16.908 16.04 18.34 16.236c1.431.195 19.816-3.895 20.279-6.06.337-1.578-.332-3.76-1.521-4.852-.736-.676-2.13-1.34-3.109-1.063-1.077.304-13.612 6.18-14.534 6.02-1.004-.171-18.369-13.265-18.369-13.265s-.511-5.038-3.361-5.524c-2.852-.486-4.687 1.61-4.125 2.493.561.885 2.111 1.079 2.842.864.732-.216.376 1.374-.731.899-1.108-.476-1.831-.638-2.017-.147-.185.49.858 1.937 2.424 2.059 1.567.122 3.882 2.34 3.882 2.34z",
    fill: "#efcec9",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m184.405 291.081-10.058 4.232s-1.731 4.354-.174 8.066c0 0 14.717-.646 15.073-7.624-.065-1.463-1.824-5.354-4.841-4.674z",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m182.956 292.431c-1.578.529-3.63 1.834-3.63 1.834v-4.021l-6.347 3.8v2.686s-4.246 1.936-8.148 4.948c-1.655 1.276 2.324 5.498 2.889 14.985.506 8.503-1.111 9.667.222 25.173l22.966-12.504s.297-18.42-2.928-32.444c0 0-1.568-5.617-5.024-4.457z",
    fill: "#efcec9",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m170.812 294.073c-2.15-1.467-4.102-7.377-2.136-14.147 1.968-6.77 9.34-6.668 9.34-6.668s6.753.188 7.987 5.386c1.11 4.662.527 7.621-1.53 9.74-2.217 2.28-11.51 7.158-13.66 5.69",
    fill: "#efcec9",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m171.058 286.029s.024-1.259 1.202-1.259c.746 0 1.018.815 1.018 1.366 0 .641-.677 1.533-1.738 1.533zm19.85 43.303-13.925 7.555c-.93 6.135 2.494 31.512 2.494 31.512l2.923 26.042c-1.578-.818-3.16-.824-3.887-.42-.888.493-1.678 1.481 1.383 4.542 1.113 1.113 5.235 4.161 7.902 3.556 1.87-.425.976-3.972.976-3.972l-1.174-30.595s5.187-15.194 5.53-24.567c.297-8.074-2.222-13.653-2.222-13.653",
    fill: "#efcec9",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m190.76 327.801s3.926 5.11 2.89 17.999c-1.038 12.889-2.199 48.17-2.199 48.17s-11.098.305-11.835-1.626c-.914-2.395-3.029-47.927-3.176-50.371-.149-2.444-1.094-6.304-1.094-6.304z",
    fill: "#e6e8e8",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m188.876 397.306c-.667.52-2.148 1-3.481.37s-2.666-1.74-2.666-2.665l-.075-.704s-3.407-2.444-6.185-.777c-2.778 1.666-.963 5.184 2.555 7.629 3.519 2.444 7.153 4.36 9.704 2.925 2.962-1.667 1.605-6.273.127-7.124l.02.347z",
    fill: "#003c57",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m186.365 331.751-18.423 10.085 5.116 58.097-.766-.48c-1.876-1.186-3.93-1.226-5.467-.339-1.537.89.43 3.597 2.603 5.277 2.172 1.678 5.53 4.344 7.999 3.653 2.469-.69 1.73-4.344 1.73-4.344s0-31.885.32-35.3c.32-3.416 7.493-29.66 6.888-36.649",
    fill: "#efcec9",
    fillRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m167.799 340.986s2.878 54.32 2.872 55.498 12.138 1.569 12.583.458c.444-1.111 5.762-57.335 3.433-66.992z",
    fill: "#e6e8e8",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m172.576 296.913s1.519 1.704 5.185-.259c3.667-1.963 1.704-2.63 1.704-2.63s2.444-1.37 3.037-1.592c.592-.222 2.22-1 3.963 1.037 1.74 2.037 3.134 8.006 3.493 10.354.358 2.35 1.502 24.392 1.642 24.973 0 0-5.427 7.087-24.32 14.041 0 0-.741-16.185-.444-19.962.296-3.777-2-21.48-2-21.48s6.777-4.482 7.74-4.482",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m166.612 278.47s-2.205-3.053.84-2.617c1.037.147 1.974 1.184 1.974 1.184z",
    fill: "#d6a732",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m175.796 286.766c2.418 1.247 7.343 3.986 10.075 2.222 2.733-1.765 4-5.036 2.666-10.37-.668-2.673-5.223-8.141-14.74-6.666-5.26.814-7.036 5.48-7.185 6.518 0 0 4.593 5.926 9.184 8.296z",
    fill: "#f9c638",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m175.796 286.766c2.418 1.247 7.343 3.986 10.075 2.222 2.733-1.765 4-5.036 2.666-10.37-.668-2.673-5.223-8.141-14.74-6.666-5.26.814-7.036 5.48-7.185 6.518 0 0 4.593 5.926 9.184 8.296z",
    fill: "#eddc13",
    fillRule: "evenodd"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m170.342 272.693s8.444-1.855 12.664 4.517c4.223 6.37 1.63 13.11 1.63 13.11",
    stroke: "#d6c313"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m171.206 271.926s9.333-1.405 13.554 4.965c4.22 6.37 1.333 12.962 1.333 12.962",
    stroke: "#d6c313"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m154.6 273.031c-.593.622-.877 1.794-.635 2.618.241.824.918.988 1.512.367.593-.622.877-1.794.635-2.618s-.919-.988-1.512-.367",
    fill: "#67bfb5",
    fillRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m154.561 276.371 17.514 4.25.878-3.711-17.398-4.215z",
    fill: "#67bfb5",
    fillRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m172.751 277.508c-.594.621-.878 1.794-.636 2.618s.919.988 1.512.366c.593-.621.877-1.794.635-2.618-.241-.824-.918-.988-1.511-.366",
    fill: "#ceccd8",
    fillRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m177.643 273.846c-.869-1.141-2.727-1.918-4.149-1.735-.686.087-1.142.382-1.337.792v.002c-.015.029-.027.059-.038.09l-.638 1.525 1.805.746c.68.49 1.464.814 2.29.947l1.785.739.611-1.493c.216-.441.125-1.017-.329-1.613",
    fill: "#d0ced9",
    fillRule: "evenodd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m172.579 285.916c-1.423.181-3.28-.596-4.15-1.736-.87-1.142-.42-2.214 1.003-2.396 1.422-.182 3.28.595 4.149 1.735.869 1.141.42 2.213-1.002 2.396",
    fill: "#3dafa7",
    fillRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m168.042 282.64 4.013-9.513 5.907 2.363-4.093 9.686z",
    fill: "#3dafa7",
    fillRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m176.63 276.279c-1.422.182-3.279-.595-4.148-1.736-.87-1.14-.42-2.213 1.003-2.395 1.422-.182 3.28.595 4.148 1.735.868 1.141.42 2.213-1.003 2.396z",
    fill: "#67bfb5",
    fillRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m164.109 305.322c2.226 1.691 5.731 1.593 6.62.26 1.671-2.507.692-4.346-.79-5.087-.447-.224-15.009-7.485-15.259-8.196-.472-1.35 4.19-10.06 4.567-10.934.784-1.816 4.15-.713 4.792-1.65.426-.625-1.188-2.009-1.188-2.009 2.02-1.759 3.624-5.046 1.508-6.642-1.525-1.15-3.582-.074-5.333 1.58-2.125 2.012-3.074 3.852-3.074 3.852s-8.525 16.36-7.424 17.588c3.915 4.365 14.947 10.757 15.581 11.238",
    fill: "#efcec9",
    fillRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m171.603 301.05-10.294-5.041s-4.25 1.972-5.672 5.736c0 0 10.84 8.736 15.896 3.912 1.57-1.356 2.361-3.104.07-4.607z",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m179.172 401.676c-.666.52-2.147 1-3.48.37-1.334-.63-2.668-1.74-2.668-2.665l-.073-.704s-3.409-2.444-6.186-.777c-2.777 1.666-.963 5.184 2.555 7.629 3.52 2.444 7.154 4.36 9.705 2.925 2.962-1.666 1.605-6.273.127-7.124l.02.347z",
    fill: "#003c57",
    fillRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m144.825 283.968c0 .324.228.455.508.293.28-.161.508-.555.508-.88 0-.322-.228-.454-.508-.292s-.508.556-.508.879",
    fill: "#ebdcd6",
    fillRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m142.398 281.802c-.022-.017-.052-.02-.087 0-.034.023-.062.053-.083.088-.02.036-.032.076-.035.117 0 .045.021.067.05.076l-.003.005 2.743 2.218.715-1.246z",
    fill: "#f4f4f4",
    fillRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m144.394 284.106c0-.524.37-1.163.824-1.426.192-.11.365-.132.505-.086l.02-.007.274.159-.043.073c.047.106.069.221.067.337 0 .525-.369 1.164-.823 1.427-.103.062-.219.099-.338.109l-.04.068-.196-.117c-.153-.084-.25-.27-.25-.536",
    fill: "#c6c6c5",
    fillRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m144.588 284.218c0 .525.37.738.825.476.454-.263.823-.902.823-1.427s-.37-.737-.823-.476c-.455.263-.825.902-.825 1.427",
    fill: "#f4f4f4",
    fillRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m183.254 396.942s2.347-31.868 3.442-39.463l-2.111 36.316-.714-.035z",
    fill: "#c6c6c5",
    fillRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m401.278 559.556.404-.422-1.883-.833c-2.153-1.268-5.137-1.102-8.44.804-6.561 3.788-11.88 13-11.88 20.576 0 3.969 1.469 6.686 3.803 7.843l2.111 1.029.163-.418c1.717.122 3.695-.378 5.803-1.596 6.561-3.788 11.879-13 11.879-20.576 0-2.786-.724-4.957-1.96-6.407",
    fill: "#003c57",
    fillRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m405.524 567.046c0 7.576-5.318 16.788-11.879 20.576-6.56 3.787-11.88.717-11.88-6.858 0-7.576 5.32-16.788 11.88-20.576 6.561-3.788 11.88-.717 11.88 6.858",
    fill: "#005477",
    fillRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m397.381 571.747c0 2.384-1.673 5.281-3.737 6.473-2.065 1.192-3.738.225-3.738-2.158s1.673-5.28 3.738-6.472c2.064-1.193 3.737-.226 3.737 2.157z",
    fill: "#003c57",
    fillRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m354.189 570.929 22.61-13.055 10.263 5.924-22.611 13.055z",
    fill: "#c6b014",
    fillRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m376.8 557.874-.001-13.619-33.119 19.492v13.446z",
    fill: "#d6c313",
    fillRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m376.799 544.255 20.937 12.183v13.807l-20.936-12.371z",
    fill: "#d6c313",
    fillRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m362.09 590.868-21.14-12.205c-.365-.211-.668-.514-.878-.879-.211-.366-.322-.78-.322-1.201v-12.874l23.363 13.49c.406.235.867.359 1.336.359.47 0 .931-.124 1.337-.359l34.993-20.235v12.898c0 .843-.449 1.622-1.178 2.043l-32.79 18.963c-.718.414-1.531.632-2.36.632s-1.642-.218-2.36-.632",
    fill: "#eddc13",
    fillRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m325.991 562.15s-7.627-3.834-8.18-5.17c-.551-1.335-1.268-20.156.707-21.152 1.442-.728 3.72-.635 5.079.238.84.538 1.838 1.719 1.82 2.736-.021 1.118-2.52 14.736-2.131 15.587.423.927 5.316 5.952 5.316 5.952s6.218-1.046 6.197 1.848c-.01 1.317-4.254.224-4.747.024-.495-.199 6.514 1.593 5.72 3.666-.794 2.072-4.646 2.558-7.21.38-2.563-2.176-1.594-3.472-2.57-4.11",
    fill: "#e1b2a0",
    fillRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m339.75 563.709 1.864-1.076 24.817 14.193-.743.43c-.376.217-.802.331-1.236.331-.435 0-.861-.114-1.237-.331l-23.464-13.547z",
    fill: "#eddc13",
    fillRule: "evenodd"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m333.781 584.381c0 .686-.48.964-1.074.621s-1.075-1.177-1.075-1.862c0-.686.48-.964 1.075-.621.594.342 1.075 1.176 1.075 1.862",
    fill: "#d6c313",
    fillRule: "evenodd"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m364.461 575.667-.01-.71c0-5-5.411-8.124-9.74-5.625l-22.899 13.222 1.543 2.581 22.375-13.975c2.682-1.675 6.152-.063 6.213 3.1l2.519 1.407z",
    fill: "#d6c313",
    fillRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m400.586 557.109c.093-.054.17-.131.224-.224s.082-.199.082-.306-.028-.213-.082-.306-.131-.17-.224-.224l-22.022-12.71h.003c-.537-.31-1.146-.473-1.767-.473-.62 0-1.229.163-1.766.473l-35.283 20.37 1.996 1.153 33.192-19.402c.538-.315 1.15-.482 1.774-.484.623-.001 1.236.162 1.776.474l19.218 11.095-35.125 20.25.703.406c.8.462 1.786.459 2.584-.007z",
    fill: "#eddc13",
    fillRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m316.6 574.658c0 .686-.48.963-1.076.62-.594-.343-1.075-1.177-1.075-1.862 0-.686.481-.963 1.075-.62.595.342 1.075 1.176 1.075 1.862",
    fill: "#d6c313",
    fillRule: "evenodd"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m347.5 566.013-.014-.923c0-5-5.412-8.123-9.741-5.624l-22.898 13.22 1.543 2.583 22.374-13.975c2.682-1.676 6.205.149 6.267 3.312z",
    fill: "#d6c313",
    fillRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m324.16 534.15 5.622 9.352s-1.172 4.536-4.618 6.614c0 0-11.502-9.206-7.671-15.05.916-1.143 4.633-3.245 6.667-.916",
    fill: "#003c57",
    fillRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m324.534 536.094c.96 1.358 1.847 3.622 1.847 3.622l2.372-3.246 2.883 6.813-1.585 2.169s1.325 2.606 2.699 7.34c.582 2.008-4.162 4.53-10.216 11.857-4.887 5.914-.904.324-6.565 15.743l-19.631-19.2s10.63-15.045 21.509-24.465c0 0 4.58-3.61 6.687-.633z",
    fill: "#e1b2a0",
    fillRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m333.368 544.586c2.603.084 7.666-3.535 10.073-10.162 2.406-6.627-3.605-10.894-3.605-10.894s-5.564-3.834-9.628-.366c-3.646 3.11-4.922 5.843-4.51 8.766.443 3.148 5.067 12.572 7.67 12.656",
    fill: "#e1b2a0",
    fillRule: "evenodd"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m345.965 534.466s3.583-1.162.868-2.607c-.925-.493-2.294-.21-2.294-.21l1.427 2.818zm-11.144 1.919c.005.217-.033.434-.112.636-.079.203-.199.387-.35.543-.152.155-.334.279-.534.364-.2.084-.416.128-.633.128s-.433-.043-.633-.128c-.201-.084-.382-.208-.534-.364-.152-.155-.271-.34-.351-.542-.079-.202-.117-.419-.112-.636.01-.425.187-.829.491-1.127.304-.297.713-.463 1.138-.463s.834.166 1.138.463c.305.297.481.701.492 1.126z",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m336.822 534.682c0 .214-.043.426-.125.624-.081.198-.202.377-.353.529-.151.151-.331.271-.529.353-.197.082-.409.124-.623.124-.215 0-.426-.042-.624-.124s-.378-.202-.529-.353c-.151-.152-.271-.331-.353-.529s-.124-.41-.124-.624c0-.432.171-.847.477-1.153.306-.305.72-.477 1.153-.477.432 0 .846.172 1.152.477.306.306.478.721.478 1.153",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m339.133 534.15c.008.219-.028.437-.107.641-.078.204-.197.391-.349.548-.152.158-.334.283-.536.369-.201.085-.418.129-.637.129s-.435-.044-.637-.129c-.201-.086-.383-.211-.535-.369-.152-.157-.271-.344-.349-.548-.079-.204-.115-.422-.108-.641.015-.422.193-.822.497-1.115.304-.294.71-.458 1.132-.458.423 0 .829.164 1.133.458.303.293.482.693.496 1.115zm-6.221 1.778c0 .432-.171.847-.477 1.153-.306.305-.72.477-1.153.477-.432 0-.847-.172-1.152-.477-.306-.306-.478-.721-.478-1.153s.172-.847.478-1.153c.305-.305.72-.477 1.152-.477.433 0 .847.172 1.153.477.306.306.477.721.477 1.153z",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m331.03 535.184c.008.219-.028.437-.107.641-.078.204-.197.391-.349.548-.152.158-.334.283-.536.369-.201.085-.418.129-.637.129-.218 0-.435-.044-.636-.129-.202-.086-.384-.211-.536-.369-.152-.157-.271-.344-.349-.548-.079-.204-.115-.422-.108-.641.011-.425.187-.829.492-1.126.304-.297.713-.464 1.138-.464s.834.167 1.138.464c.305.297.481.701.491 1.126",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m329.094 535.004c.006.217-.032.434-.112.636-.079.202-.198.387-.35.543-.152.155-.334.279-.534.363-.2.085-.416.128-.633.128-.218 0-.433-.043-.633-.128-.201-.084-.382-.208-.534-.363-.152-.156-.271-.341-.35-.543-.08-.202-.118-.419-.113-.636 0-.432.172-.847.478-1.153.306-.305.72-.477 1.152-.477.433 0 .847.172 1.153.477.306.306.477.721.477 1.153",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m329.2 533.151c.005.217-.033.434-.112.636-.08.202-.199.387-.351.543-.152.155-.333.279-.533.363-.201.085-.416.128-.634.128-.217 0-.432-.043-.633-.128-.2-.084-.381-.208-.533-.363-.152-.156-.271-.341-.351-.543-.079-.202-.117-.419-.112-.636.01-.425.187-.829.491-1.126.305-.297.713-.464 1.138-.464.426 0 .834.167 1.139.464.304.297.48.701.491 1.126z",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m327.819 532.769c0 .432-.172.847-.478 1.153-.305.305-.72.477-1.152.477-.433 0-.847-.172-1.153-.477-.306-.306-.477-.721-.477-1.153s.171-.847.477-1.153c.306-.305.72-.477 1.153-.477.432 0 .847.172 1.152.477.306.306.478.721.478 1.153zm9.613 3.034c.005.217-.033.434-.113.636-.079.202-.198.387-.35.543-.152.155-.333.279-.534.363-.2.085-.415.128-.633.128-.217 0-.433-.043-.633-.128-.2-.084-.382-.208-.534-.363-.152-.156-.271-.341-.35-.543-.08-.202-.118-.419-.112-.636 0-.432.171-.847.477-1.153.306-.305.72-.477 1.153-.477.432 0 .847.172 1.152.477.306.306.478.721.478 1.153",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m339.918 534.931c0 .214-.042.426-.124.624-.082.197-.202.377-.354.528-.151.152-.331.272-.528.354-.198.081-.41.124-.624.124-.214-.001-.426-.043-.624-.125s-.377-.202-.529-.353c-.151-.152-.271-.331-.353-.529s-.124-.41-.124-.624c0-.432.172-.847.478-1.153.305-.305.72-.477 1.152-.477s.847.172 1.153.477c.305.306.477.721.477 1.153",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m341.994 533.358c0 .214-.042.426-.124.624s-.202.377-.353.529c-.151.151-.331.271-.529.353s-.41.124-.624.124-.426-.042-.623-.124c-.198-.082-.378-.202-.529-.353-.152-.152-.272-.331-.354-.529-.081-.198-.124-.41-.124-.624 0-.432.172-.847.478-1.153.305-.305.72-.477 1.152-.477.433 0 .847.172 1.153.477.306.306.477.721.477 1.153z",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m337.917 537.946s.724-1.029-.228-1.725c-.602-.44-1.302.057-1.627.502-.378.518-.358 1.636.498 2.262",
    fill: "#e1b2a0",
    fillRule: "evenodd"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m342.841 534.829c.008.219-.029.437-.107.641-.079.204-.197.391-.349.548-.152.158-.335.283-.536.369-.201.085-.418.129-.637.129s-.435-.044-.637-.129c-.201-.086-.384-.211-.536-.369-.152-.157-.27-.344-.349-.548-.078-.204-.115-.422-.107-.641.015-.422.193-.822.497-1.115.304-.294.71-.458 1.132-.458s.828.164 1.132.458c.304.293.482.693.497 1.115z",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m345.793 534.943c0 .214-.042.426-.124.624s-.202.377-.353.529c-.152.151-.331.271-.529.353s-.41.124-.624.124-.426-.042-.624-.124c-.197-.082-.377-.202-.528-.353-.152-.152-.272-.331-.354-.529s-.124-.41-.124-.624c0-.432.172-.847.478-1.153.305-.305.72-.477 1.152-.477s.847.172 1.153.477c.305.306.477.721.477 1.153",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m345.527 536.438c0 .432-.172.847-.478 1.153-.306.305-.72.477-1.152.477-.433 0-.847-.172-1.153-.477-.306-.306-.477-.721-.477-1.153s.171-.847.477-1.153c.306-.305.72-.477 1.153-.477.432 0 .846.172 1.152.477.306.306.478.721.478 1.153",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m347.901 535.444c0 .214-.043.426-.124.624-.082.198-.202.377-.354.529-.151.151-.331.271-.529.353-.197.082-.409.124-.623.124s-.426-.042-.624-.124-.378-.202-.529-.353c-.151-.152-.271-.331-.353-.529s-.124-.41-.124-.624c0-.432.171-.847.477-1.153.306-.305.72-.477 1.153-.477.432 0 .847.172 1.152.477.306.306.478.721.478 1.153",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m348.235 533.775c.005.217-.033.434-.112.636-.08.202-.199.387-.351.543-.151.155-.333.279-.533.363-.201.085-.416.128-.633.128-.218 0-.433-.043-.633-.128-.201-.084-.382-.208-.534-.363-.152-.156-.271-.341-.351-.543-.079-.202-.117-.419-.112-.636.011-.425.187-.829.491-1.126.305-.297.713-.464 1.139-.464.425 0 .833.167 1.138.464.304.297.481.701.491 1.126z",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m296.339 561.191 12.21 12.048c-.718 6.164-2.49 28.31-2.49 28.31l-2.923 26.04c1.578-.816 3.16-.823 3.887-.42.888.494 1.678 1.481-1.384 4.543-1.112 1.112-5.234 4.16-7.901 3.555-1.87-.425-.976-3.97-.976-3.97l1.174-30.596s-8.703-16.69-6.57-25.823c1.837-7.869 4.973-13.687 4.973-13.687",
    fill: "#e1b2a0",
    fillRule: "evenodd"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m297.36 560.043s-4.847 4.706-7.236 17.413 3.959 49.663 3.959 49.663 11.098.304 11.835-1.627c.914-2.394 1.03-44.884 1.816-47.203s2.712-5.794 2.712-5.794z",
    fill: "#76b2cd",
    fillRule: "evenodd"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m296.659 630.456c.667.518 2.148 1 3.48.37 1.334-.63 2.667-1.74 2.667-2.667l.075-.704s3.407-2.444 6.185-.777c2.778 1.666.963 5.184-2.555 7.63-3.52 2.443-7.153 4.36-9.704 2.924-2.962-1.666-1.605-6.273-.127-7.124l-.021.347z",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m298.578 565.826 17.392 14.565-3.493 52.69.767-.48c1.876-1.185 3.929-1.226 5.467-.338 1.537.888-.43 3.597-2.603 5.276-2.173 1.68-5.531 4.346-8 3.654-2.47-.69-1.73-4.345-1.73-4.345s0-31.884-.32-35.299c-.32-3.416-12.092-30.439-7.48-35.723",
    fill: "#e1b2a0",
    fillRule: "evenodd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m316.331 579.609s-1.472 48.846-1.466 50.024-12.137 1.568-12.583.457c-.444-1.11-10.478-59.486-2.9-65.909l16.95 15.428z",
    fill: "#76b2cd",
    fillRule: "evenodd"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m330.269 545.838s-2.23.479-4.033-3.269c-1.802-3.749.177-3.128.177-3.128s-1.165-2.549-1.513-3.078c-.347-.529-1.203-2.119-3.81-1.502-2.608.618-7.257 4.614-8.932 6.298-1.675 1.686-15.606 18.806-16.062 19.193 0 0 3.851 9.503 20.25 21.18-.87 5.661 5.7-15.337 3.236-11.346 1.991-3.225 13.9-18.144 13.9-18.144s-2.436-5.636-3.213-6.204z",
    fill: "#003c57",
    fillRule: "evenodd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m333.655 535.744c-2.687-.419-8.28-1.113-9.444-4.15s-.257-6.427 3.966-9.946c2.118-1.763 9.023-3.489 15.834 3.317 3.766 3.76 2.447 8.577 1.955 9.502 0 0-7.205 2.073-12.311 1.277",
    fill: "#fbd97c",
    fillRule: "evenodd"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m333.655 535.744c-2.687-.419-8.28-1.113-9.444-4.15s-.257-6.427 3.966-9.946c2.118-1.763 9.023-3.489 15.834 3.317 3.766 3.76 2.447 8.577 1.955 9.502 0 0-7.205 2.073-12.311 1.277",
    fill: "#eddc13",
    fillRule: "evenodd"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m346.365 527.603s-5.725-6.48-12.892-3.827c-7.168 2.65-9.053 9.623-9.053 9.623",
    stroke: "#d6c313"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m346.119 526.475s-6.704-6.644-13.871-3.993c-7.168 2.65-8.726 9.679-8.726 9.679",
    stroke: "#d6c313"
  }))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m324.981 551.592c1.9-2.05 5.371-2.558 6.477-1.397 2.078 2.179 1.43 4.16.098 5.145-.402.298-9.248 12.83-9.142 13.579.2 1.417 8.946 5.38 9.751 5.889 1.672 1.055 3.827-1.756 4.886-1.344.705.274.155 2.327.155 2.327 2.66.31 5.84 2.117 4.996 4.629-.61 1.812-2.915 2.085-5.294 1.708-2.89-.458-4.712-1.441-4.712-1.441s-16.482-8.935-16.068-10.53c1.474-5.675 8.313-17.981 8.853-18.565z",
    fill: "#e1b2a0",
    fillRule: "evenodd"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m333.26 555.148-4.974 7.49s-6.077-.818-8.89-3.695c0 0 4.873-12.962 11.441-10.575 1.983.612 3.916 4.483 2.422 6.78",
    fill: "#003c57",
    fillRule: "evenodd"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m306.362 634.826c.667.518 2.148 1 3.481.37s2.667-1.74 2.667-2.667l.074-.704s3.407-2.444 6.185-.777c2.778 1.666.963 5.184-2.555 7.63-3.519 2.443-7.153 4.36-9.704 2.924-2.962-1.666-1.605-6.273-.127-7.124l-.021.347z",
    fill: "#d45c46",
    fillRule: "evenodd"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m301.644 626.792s-5.874-26.744-5.354-43.955z",
    fill: "#0079a7",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComingSoonIlustradedEstudologia1);
export default __webpack_public_path__ + "static/media/coming-soon-ilustraded-estudologia 1.174d08ba65f7c068a6098bbea6e16b23.svg";
export { ForwardRef as ReactComponent };